import { render, staticRenderFns } from "./FunctionSettingComponent.vue?vue&type=template&id=3145d3a9"
import script from "./FunctionSettingComponent.vue?vue&type=script&lang=js"
export * from "./FunctionSettingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports